import React from 'react'
import { IconImage } from 'components/Zui/Icon'
import './index.css'

const FallbackImage = ({ onClick }) => {
    return (
        <div className="thumbnail-image-fallback-wrapper" onClick={onClick}>
            <IconImage size="xl" className="thumbnail-icon-light-grey" />
        </div>
    )
}

export default FallbackImage
